import { clearSessionNative } from './nativeSessionStore';

export function isAuthenticated(): boolean {
  return Boolean(localStorage.getItem('accessToken') && localStorage.getItem('user'));
}

export function clearAuthSession(): void {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('supabaseToken');
  localStorage.removeItem('user');
  clearSessionNative();
}
